import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const STARS = [
  { x: '12%', y: '18%', s: 3, o: 0.9 },
  { x: '28%', y: '64%', s: 2, o: 0.7 },
  { x: '45%', y: '30%', s: 2, o: 0.85 },
  { x: '58%', y: '78%', s: 3, o: 0.75 },
  { x: '71%', y: '22%', s: 2, o: 0.9 },
  { x: '83%', y: '55%', s: 3, o: 0.8 },
  { x: '90%', y: '80%', s: 2, o: 0.7 },
  { x: '18%', y: '85%', s: 2, o: 0.75 },
  { x: '65%', y: '90%', s: 3, o: 0.65 },
];

const KnameStart = () => {
  const navigate = useNavigate();

  const handleStart = () => {
    navigate('/korean-name-generator/form');
  };

  return (
    <div className='relative flex min-h-[100svh] flex-col items-center justify-center overflow-hidden bg-[#1a1420] px-6 py-16'>
      {/* 중앙 글로우 */}
      <div
        aria-hidden
        className='pointer-events-none absolute left-1/2 top-1/2 h-[480px] w-[1100px] -translate-x-1/2 -translate-y-1/2'
        style={{
          background:
            'radial-gradient(ellipse, rgba(214,162,75,0.16) 0%, rgba(160,120,70,0.15) 10%, transparent 70%)',
        }}
      />

      {/* 별 */}
      {STARS.map((star, i) => (
        <span
          key={i}
          aria-hidden
          className='pointer-events-none absolute rounded-full bg-[#e8d5b0]'
          style={{
            left: star.x,
            top: star.y,
            width: star.s,
            height: star.s,
            opacity: star.o,
            boxShadow: `0 0 ${star.s * 1}px ${star.s}px rgba(232,213,176,0.1)`,
          }}
        />
      ))}

      {/* 헤드라인 */}
      <h1
        className='relative z-10 max-w-3xl text-center text-5xl leading-none text-[#f3ede2] md:text-[78px] md:font-semibold'
        style={{ fontFamily: "'Cormorant Garamond', serif" }}
      >
        Which <span className='text-[#f2d29a]'>Korean name</span>
        <br />
        suits you best?
      </h1>

      {/* CTA */}
      <button
        type='button'
        onClick={handleStart}
        className='relative z-10 mt-12 h-14 rounded-full bg-[#d6a24b] px-8 text-[17px] font-semibold text-[#17111f] transition-all hover:-translate-y-1 hover:brightness-110 shadow-[0_10px_30px_-12px_rgba(214,162,75,0.55)]'
      >
        Find My Korean Name
      </button>

      {/* 푸터 */}
      <footer className='absolute bottom-8 z-10 text-sm text-[#fff5e694]'>
        © 2026 Koready
      </footer>
    </div>
  );
};

export default KnameStart;
